// extracted by mini-css-extract-plugin
export default {"infiniteScrollContainer":"styles_infiniteScrollContainer__6bmeb"};